import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('plans.routes.index'),
        name: 'plans.index',
        component: () =>
            import(/* webpackChunkName: "plans" */ '@/views/plans/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('plans.breadcrumbs.index'),
                    to: { name: 'plans.index' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('plans.routes.edit') + '/:id',
        name: 'plans.edit',
        component: () =>
            import(/* webpackChunkName: "plans" */ '@/views/plans/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('plans.breadcrumbs.index'),
                    to: { name: 'plans.index' },
                    disable: false,
                },
                {
                    text: i18n.t('form.actions.edit'),
                    to: { name: 'plans.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('plans.routes.module'),
        name: 'plans.module',
        component: () =>
            import(
                /* webpackChunkName: "plans" */ '@/views/plans/modules/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('plans.breadcrumbs.index'),
                    to: { name: 'plans.index' },
                    disable: false,
                },
                {
                    text: i18n.t('plans.breadcrumbs.modules'),
                    to: { name: 'plans.module' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('plans.routes.module-edit'),
        name: 'plans.module.edit',
        component: () =>
            import(
                /* webpackChunkName: "plans" */ '@/views/plans/modules/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('plans.breadcrumbs.index'),
                    to: { name: 'plans.index' },
                    disable: false,
                },
                {
                    text: i18n.t('plans.breadcrumbs.modules'),
                    to: { name: 'plans.module.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
